import React from 'react';
import Responsive from 'react-responsive';

export const Default = props => <Responsive {...props} query={'(min-width: 746px)'} />;
export const Mobile = props => <Responsive {...props} query={'(max-width: 745px)'} />;


// WEBPACK FOOTER //
// ./src/js/components/Breakpoints.js